import type { ProductOption } from "../ProductOption.js";
import type { ProductOptions } from "../ProductOptions.js";
import { restrictedProductOptionsForExpress } from "../restrictedProductOptionsForExpress.js";
import { doesProductHaveOption } from "./doesProductHaveOption.js";

export function isProductOptionEnabled(
	option: ProductOption,
	enabledOptions: ProductOptions,
	isExpress: boolean,
): boolean {
	return (
		doesProductHaveOption(enabledOptions, option) &&
		(!isExpress || !restrictedProductOptionsForExpress.includes(option))
	);
}
